namespace Ir.Components.Workbook.Dashboard {
    interface IViewModel {
        config: WorkbookConfig;
        dashboard: Dashboard;
        dispose: Function;
        dxScrollViewOptions: DevExpress.ui.dxScrollView.Properties;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        let self = this;
        self.config = params.config;
        self.dashboard = params.dashboard ?? this.config.activeTab().dashboard;
        
        this.dxScrollViewOptions ={
            scrollByContent: true,
            scrollByThumb: true,
            showScrollbar: 'onHover',
            useNative: true,
            onInitialized(e) {
                self.dashboard.setScrollViewInstance(e.component);
                $(".dx-scrollable-container", e.element).addClass("scrollable-dashboard");
            }
        };

        let resizeObserverDispose;
        if (!params.printing) {
            
            let update = irGlobal.debounce(() => {
                self.dashboard.updateMoveableRect();
                //self.dashboard.configureResizableDraggable();
            }, 300);
            this.dxScrollViewOptions.onScroll = update;
            self.dashboard.scrollTop();
            self.dashboard?.setZoom(componentInfo.element);
            update();

            resizeObserverDispose = ResizeService.createResizeObserverForComponent(componentInfo.element, 
                function () { self.dashboard?.setZoom(componentInfo.element); });
        }

        self.dispose = function () {
            if (resizeObserverDispose) {
                resizeObserverDispose();
            }
        }
    }
}